import {TypingEffect} from '../../modules/typingEffect.js';

/** Runs the select prompt only while the desktop control is idle and visible. */
export class SelectTypingEffect {
    /** @type {AbortController} */
    controller = new AbortController();
    /** @type {IntersectionObserver|null} */
    observer = null;
    /** @type {TypingEffect|null} */
    effect = null;
    visible = false;
    enabled = false;
    running = false;

    /**
     * @param {HTMLElement} root
     * @param {HTMLElement} display
     */
    constructor(root, display) {
        this.display = display;
        this.placeholder = root.dataset.placeholder;
        const texts = root.dataset.typingTexts?.split(',').map(text => text.trim()).filter(Boolean);
        if (!texts?.length) return;
        const prefix = this.placeholder.replace(/[.…]+$/, '').trim();
        this.effect = new TypingEffect(display, texts.map(text => `${prefix} ${text}`));
        this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.sync();
        });
        this.observer.observe(root);
        document.addEventListener('visibilitychange', () => this.sync(), {signal: this.controller.signal});
    }

    /** @param {boolean} enabled */
    update(enabled) {
        this.enabled = enabled;
        this.sync();
    }

    sync() {
        const running = this.enabled && this.visible && document.visibilityState === 'visible';
        if (!this.effect || running === this.running) return;
        this.running = running;
        if (running) this.effect.start();
        else {
            this.effect.destroy();
            this.display.textContent = this.placeholder;
        }
    }

    destroy() {
        this.effect?.destroy();
        this.observer?.disconnect();
        this.controller.abort();
    }
}
